import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

type DropdownLoadingSkeletonProps = {
  style?: React.CSSProperties;
  isLabel?: boolean;
};

const DropdownLoadingSkeleton = ({
  style,
  isLabel,
}: DropdownLoadingSkeletonProps) => {
  return (
    <>
      <Skeleton height={18} width={100} />
      <Skeleton height={32} style={{ borderRadius: '20px', ...style }} />
    </>
  );
};

export default DropdownLoadingSkeleton;
